/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetStockups200ResponseAllOfData } from './GetStockups200ResponseAllOfData';
import {
    GetStockups200ResponseAllOfDataFromJSON,
    GetStockups200ResponseAllOfDataFromJSONTyped,
    GetStockups200ResponseAllOfDataToJSON,
} from './GetStockups200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetStockups200ResponseAllOf
 */
export interface GetStockups200ResponseAllOf {
    /**
     * 
     * @type {GetStockups200ResponseAllOfData}
     * @memberof GetStockups200ResponseAllOf
     */
    data: GetStockups200ResponseAllOfData;
}

/**
 * Check if a given object implements the GetStockups200ResponseAllOf interface.
 */
export function instanceOfGetStockups200ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function GetStockups200ResponseAllOfFromJSON(json: any): GetStockups200ResponseAllOf {
    return GetStockups200ResponseAllOfFromJSONTyped(json, false);
}

export function GetStockups200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStockups200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetStockups200ResponseAllOfDataFromJSON(json['data']),
    };
}

export function GetStockups200ResponseAllOfToJSON(value?: GetStockups200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetStockups200ResponseAllOfDataToJSON(value.data),
    };
}

